[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 8,
                "y": 7,
                "key": "xMSu7"
            },
            {
                "x": 7,
                "y": 7,
                "key": "DiISM"
            },
            {
                "x": 7,
                "y": 8,
                "key": "b-wb2"
            },
            {
                "x": 4,
                "y": 8,
                "key": "XQluo"
            },
            {
                "x": 4,
                "y": 8,
                "key": "4St2N"
            },
            {
                "x": 4,
                "y": 7,
                "key": "i1otH"
            },
            {
                "x": 4,
                "y": 7,
                "key": "RBCT-"
            },
            {
                "x": 3,
                "y": 7,
                "key": "4ZlnB"
            },
            {
                "x": 3,
                "y": 5,
                "key": "NC7Kg"
            },
            {
                "x": 4,
                "y": 5,
                "key": "6zmsi"
            },
            {
                "x": 4,
                "y": 4,
                "key": "UmGU9e9DGAW2cgtDM5LDE"
            },
            {
                "x": 4,
                "y": 4,
                "key": "Y_QtY"
            },
            {
                "x": 6,
                "y": 4,
                "key": "OpASM"
            },
            {
                "x": 6,
                "y": 3,
                "key": "k0Le7"
            },
            {
                "x": 9,
                "y": 3,
                "key": "3UCxq"
            },
            {
                "x": 9,
                "y": 4,
                "key": "HRP1-"
            },
            {
                "x": 11,
                "y": 4,
                "key": "87Arv"
            },
            {
                "x": 11,
                "y": 5,
                "key": "m0tm9EaEvdCqJFffxHmqg"
            },
            {
                "x": 12,
                "y": 5,
                "key": "NjyBq"
            },
            {
                "x": 12,
                "y": 7,
                "key": "fSGPv"
            },
            {
                "x": 11,
                "y": 7,
                "key": "yISFx"
            },
            {
                "x": 11,
                "y": 7,
                "key": "VjHMM"
            },
            {
                "x": 11,
                "y": 7,
                "key": "U2EqybwO2xGhP4bxOgYGF"
            },
            {
                "x": 11,
                "y": 8,
                "key": "SNZ-8"
            },
            {
                "x": 8,
                "y": 8,
                "key": "tgAlOo15-hexJ72EDJs-g"
            }
        ]
    }
]